import { CHANGE_LANGUAGE } from '../mutation-types';

export default {
  namespaced: true,
  state: {
    language: 'en',
  },
  mutations: {
    [CHANGE_LANGUAGE](state, lang) {
      localStorage.setItem('language', lang);
      state.language = lang;
      window.Vue.$options.i18n.locale = lang;
    },
  },
  actions: {
    change({ commit }, lang) {
      commit(CHANGE_LANGUAGE, lang);
    },
  },
  getters: {
    current(state) {
      return state.language;
    },
  },
};
